import React from 'react';
import { Icon, Tooltip } from '@syneto/compass-react';
import { activationKeyPdfTemplate } from './activationPdfStyles';
import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';

export const ActivationPdf = (props) => {
	const { activationKey, createdAt } = props;

	return (
		<a
			className="ms-2"
			onClick={ (e) => {
				const docDefinition = activationKeyPdfTemplate(activationKey, createdAt);
				const { vfs } = vfsFonts.pdfMake;

				pdfMake.vfs = vfs;
				pdfMake.createPdf(docDefinition).download(`${ new Date().valueOf() }.pdf`);
				e.stopPropagation();
			} }
			style={ { cursor: 'pointer' } }
		>
			<Tooltip text="Download activation PDF" placement="top">
				<span>
					<Icon name="fa fa-file-pdf" aria-hidden="true"/>
				</span>
			</Tooltip>
		</a>
	);
};
